import { useTranslation } from 'react-i18next'

import { Alert, CardContent, CardDashboard, Copy, Flex } from '@percent/lemonade'

const ACROBAT_CONFIG_NAME = 'Acrobat For Nonprofits - new'

function buildRedemptionLink(language: string, code: string): string {
  const [lang, country] = language.split('-')

  return `https://commerce.adobe.com/store/email?items%5B0%5D%5Bid%5D=6E0BF6C6D5C282891C79A4EFD463BAF3&items%5B0%5D%5Bq%5D=1&co=${country}&lang=${lang}&cli=percent_np&sdid=NLMHR3YX&mv=affiliate&npac=${code}`
}

type RedemptionProps = {
  code?: string | null
  configurationName?: string | null
  language?: string
}

export function ValidationSubmissionRedemption({ code, configurationName, language }: RedemptionProps) {
  const { t } = useTranslation()

  if (!code) return null

  const redemptionLink =
    configurationName === ACROBAT_CONFIG_NAME && language?.includes('-') ? buildRedemptionLink(language, code) : null

  return (
    <CardDashboard title={t('typography.redemptions')}>
      <Flex direction="column" gap={16}>
        <Alert variant="warning" title={t('typography.sensitiveCode')} />
        <CardContent title={t('typography.redemptionCodeSent')}>
          <span style={{ wordBreak: 'break-all' }}>{code}</span>
        </CardContent>
        {redemptionLink && (
          <CardContent title={t('typography.redemptionLinkSent')}>
            <Copy text={redemptionLink}>
              <span style={{ wordBreak: 'break-all', minWidth: 0 }}>{redemptionLink}</span>
            </Copy>
          </CardContent>
        )}
      </Flex>
    </CardDashboard>
  )
}
